export default "__VITE_ASSET__CCedwIYy__"